<template>
  <div>
    <page-header
      title="Chart of Accounts"
      breadcrumb="Accounting > Chart of Accounts"
    />

    <div class="bg-white py-3 px-2 flex items-center w-full justify-between">
      <div class="w-5/12 justify-start flex items-center">
        <div class="table__search-input-wrapper w-full opacity-75">
          <span class="pr-2 opacity-50"><search-icon /> </span>

          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="searchString"
          />
          <img
            class="cursor-pointer"
            src="@/assets/images/icons/search.svg"
            alt="search icon"
          />
        </div>
      </div>
      <div class="select">
        <el-select
          v-model="category"
          class="w-full"
          placeholder="--Acc. Category--"
        >
          <el-option
            v-for="type in ['cardTypes']"
            :key="type"
            :label="type"
            :value="type"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select">
        <el-select
          v-model="category"
          class="w-full"
          placeholder="--Select Group--"
        >
          <el-option
            v-for="type in ['cardTypes']"
            :key="type"
            :label="type"
            :value="type"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select">
        <el-select
          v-model="category"
          class="w-full"
          placeholder="--Fin. Report--"
        >
          <el-option
            v-for="type in ['cardTypes']"
            :key="type"
            :label="type"
            :value="type"
          >
          </el-option>
        </el-select>
      </div>
      <div>
        <img src="@/assets/images/icons/filter-icon.svg" class="mr-1" />
      </div>
    </div>

    <div class="py-2 justify-end w-full flex">
      <button
        class="w-12 h-12 bg-white rounded flex justify-center items-center"
      >
        <img src="@/assets/images/icons/reload-icon.svg" />
      </button>
    </div>

    <div>
      <ChartAccountTable />
    </div>
    <PaginationControl
      :total="totalCollection"
      :pageNumber="sortOptions.pageNumber"
      @pageNumber="setPageDisplayCollection"
      @pageSize="setNumDisplayCollection"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ChartAccountTable from "@/components/3pl/Accounting/ChartAccountTable.vue";
import PaginationControl from "@/components/UI/pagination";

export default {
  components: { PageHeader, ChartAccountTable, PaginationControl },
  data() {
    return {
      searchString: "",
      category: "",
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        startDate: null,
        endDate: null,
        searchString: "",
      },
    };
  },
  methods: {
    setNumDisplayCollection(val) {
      this.sortOptions = { ...this.sortOptions, pageSize: val };
    },
    setPageDisplayCollection(val) {
      this.sortOptions = { ...this.sortOptions, pageNumber: val };
    },
  },
};
</script>

<style lang="scss" scoped>
.select {
  width: 15%;
  height: auto;
  margin-top: 13px;
}
</style>
